import { render, staticRenderFns } from "./KycDetailsSvgMark.vue?vue&type=template&id=469d0e42&scoped=true&"
import script from "./KycDetailsSvgMark.vue?vue&type=script&lang=js&"
export * from "./KycDetailsSvgMark.vue?vue&type=script&lang=js&"
import style0 from "./KycDetailsSvgMark.vue?vue&type=style&index=0&id=469d0e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469d0e42",
  null
  
)

export default component.exports